module.exports = __webpack_public_path__ + "static/media/thumbnail_salgtrakten.25ab8f9f.png";